import "./styles/LoggedOut.css";
import { useTranslation } from "react-i18next";
import "../../localisation/index"
const LoggedOut = () => {
  const {t} = useTranslation()
  return (
    <div className="logout-page">
      <p className="logout-page__msg">{t("logout")}</p>
    </div>
  );
};

export default LoggedOut;
